import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  CleaningServices,
} from "@mui/icons-material";

import {
  selectAllAreasOrganizacionales,
} from "../../redux/AreaOrganizacional/AreaOrganizacionalSlice";

import { 
  selectAllCargos 
} from '../../redux/Cargos/CargosSlice';

export const BarraDeBusqueda = ({
  cargarEmpleados,
  cleanfilter,
  setPage,
  filtroState,
  setFiltroState,
  setUpdateListApiState
}) => {

  // ? HOOK-SELECTOR
  const areasOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const cargos = useSelector(selectAllCargos);

  // ? HOOK-STATE
  const [areasOrganizacionalesList, setAreasOrganizacionalesList] = useState([]);
  const [cargosList, setCargosList] = useState([]);
  
  // ? HOOK-EFFECT PARA ACTUALIZAR LA LISTA DE AREAS ORGANIZACIONAES Y AGREGAR UNA NUEVA OPCION.
  useEffect(() => {
    setAreasOrganizacionalesList([{id: 0, nombre: "Seleccionar Área" }, ...areasOrganizacionales]);
    setCargosList([{id: 0, titulo: "Seleccionar Cargo" }, ...cargos]);
  }, [areasOrganizacionales, cargos])  

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setPage(0);
      cargarEmpleados();
    }
  };

  // * FUNCION PARA ACTUALIZAR STATE SEGUN EL NOMBRE.
  const setUpdateFiltroState = ( { name, value }) => setFiltroState({...filtroState, [name]: value, index: 0})

  return (
    <div className="row border m-1 p-2">

      <div className="col-1">
        <label className="me-2 align-self-center fw-bold text-13">Código #</label>
        <div className="input-group">
          <input
            name="codigo"
            className="form-control"
            value={filtroState.codigo}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              setUpdateFiltroState(e.target);
              e.preventDefault();
            }}
            type="number"
          />
        </div>
      </div>

      <div className="col-2">
        <label className="align-self-center fw-bold text-13">Nombre</label>
        <div className="input-group">
          <input
            name="nombre"
            className="form-control"
            value={filtroState.nombre}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              e.preventDefault();
              setUpdateFiltroState(e.target);
            }}
            type="text"
          />
        </div>
      </div>
      
      <div className="col-2">
        <label className="me-2 align-self-center fw-bold text-13">Apellido</label>
        <div className="input-group">
          <input
            name="apellido"
            className="form-control"
            value={filtroState.apellido}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              e.preventDefault();
              setUpdateFiltroState(e.target);
            }}
            type="text"
          />
        </div>
      </div>

      <div className="col-3">
        <label className="text-13 fw-bold">Cargo</label>       
          <Select
            name="cargoId"
            classNamePrefix="select"
            isSearchable={true}
            placeholder="Seleccionar Cargo"
            options={cargosList}
            getOptionLabel={(option) => option.titulo}
            getOptionValue={(option) => option.id}
            onChange={({id}) => {
              setUpdateFiltroState({ name: 'cargoId', value: id});
              setUpdateListApiState(true);
            }}
            value={cargosList.find(x => x.id === filtroState.cargoId)}
          />
      </div>

      <div className="col-3">
        <label className="text-13 fw-bold">Área</label>       
          <Select
            classNamePrefix="select"
            isSearchable={true}
            placeholder="Seleccionar Área"
            options={areasOrganizacionalesList}
            getOptionLabel={(option) => option.nombre}
            getOptionValue={(option) => option.id}
             onChange={({id}) => {
              setUpdateFiltroState({ name: 'areaOrganizacionalId', value: id});
              setUpdateListApiState(true);
            }}
            value={areasOrganizacionalesList.find(x => x.id === filtroState.areaOrganizacionalId)}
          />
      </div>
     

      <div className="col-1">
        <button
          id="btn-clean-empleados"
          className="btn btn-danger mt-4"
          type="button"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Limpiar filtros"
          onClick={() => {
            cleanfilter();
          }}
        >
          <CleaningServices />
        </button>
      </div>
          
    </div>
  );
};

export const BarraDeBusquedaMemo = React.memo(BarraDeBusqueda);